import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { purgeAbTests } from "@/lib/abTests";
import { loadUmami } from "@/lib/umami";

purgeAbTests();
loadUmami();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
